import theme from "../themes/theme";

// http://inlehmansterms.net/2014/06/09/groove-to-a-vertical-rhythm
export default function computeFontSizeAndLineHeight(size: number) {
  const fontSize = theme.typography.fontSize(size);
  const lines = Math.ceil(fontSize / theme.typography.lineHeight);
  const lineHeight = lines * theme.typography.lineHeight;
  return { fontSize, lineHeight };
}
